// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_CreateCashAdvancesBatchResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { Payroll_CashAdvanceCreatedRow } from './Payroll_CashAdvanceCreatedRow'
import type { Payroll_CashAdvanceErrorRow } from './Payroll_CashAdvanceErrorRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_CreateCashAdvancesBatchResponseDados {
created: Payroll_CashAdvanceCreatedRow[]
errors: Payroll_CashAdvanceErrorRow[]
created_count: number
error_count: number
}

export type Payroll_CreateCashAdvancesBatchResponse = ApiResponse<Payroll_CreateCashAdvancesBatchResponseDados>;

registerResponseContract('Payroll_CreateCashAdvancesBatchResponse', {
  created: {
    type: 'array',
    required: true,
    items: {
      success:    { type: 'boolean', required: true },
      advance_id: { type: 'number',  required: false },
      despesa: {
        type: 'object',
        required: false,
        fields: {
          id:             { type: 'number',  required: true },
          despesa_valor:  { type: 'number',  required: true },
          despesa_status: { type: 'number',  required: true },
        },
      },
    },
  },
  errors: {
    type: 'array',
    required: true,
    items: {
      recebimento_id: { type: 'number',  required: true },
      error:          { type: 'string',  required: true },
    },
  },
  created_count: { type: 'number',  required: true },
  error_count:   { type: 'number',  required: true },
})
